export default __webpack_public_path__ + "static/media/culture_EP5.a8a5caac.png";